<template>
  <div class="data-warning mb-3">
    <div
      v-if="disabled"
      class="alert alert-warning mt-3 mb-0 empty-data"
    >
      <icon
        icon="warning-triangle"
        class="mr-1 mt-0"
      /> There is currently no data for this {{ type }}. {{ publishedRecently ? incompleteTimeMessage : '' }}
    </div>

    <div
      v-if="incomplete && displayWarning"
      class="alert alert-warning mt-3 mb-0 incomplete-data"
    >
      <icon
        icon="warning-triangle"
        class="mr-1 mt-0"
      />
      The available data for this {{ type }} is incomplete. {{ incompleteTimeMessage }}
      <icon
        icon="closedark"
        class="close-icon"
        @click.native="closeWarning"
      />
    </div>
  </div>
</template>

<script>

const props = {
  disabled: {
    type: Boolean,
    default: false,
  },
  incomplete: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    required: true,
  },
  publishedRecently: {
    type: Boolean,
    default: false,
  },
  incompleteTimeMessage: {
    type: String,
    default: 'All data will become available 2 hours after publishing.',
  },
}

export default {
  props: props,
  data () {
    return {
      displayWarning: true,
    }
  },
  methods: {
    closeWarning () {
      this.displayWarning = false
    },
  },
}

</script>

